module.exports = __webpack_public_path__ + "static/BT-mobile-19-30179dbcbc41e0403aa7f5c12ba00ef4.jpg";